<template>
	<div class="modal " id="minutes-speaker-modal" tabindex="-1" role="dialog" aria-labelledby="myModalOptionLabel">
		<div class="modal-dialog modal-dialog-centered modal-sm" role="document">
			<div class="modal-content" style="margin-bottom:5rem;">
				<div class="modal-header">
					<h5 class="modal-title" id="myModalOptionLabel">発言者</h5>
					<button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
				</div>
				<div class="modal-body">
					<form action="#">
						<div class="minutes_speaker_parent">
							<select name="minutes_speaker" id="minutes-speaker-modal-minutes_speaker" size="10" class="form-control"></select>
						</div>
						<div class="speaker_history"></div>
						<input type="text" name="dummytext" class="form-control" style="width: 1px;">
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import { nanoid } from 'nanoid'
import $ from "jquery";
import 'select2';
window.$ = window.jQuery = $;
require('select2/dist/js/i18n/ja');
window.$.fn.select2.defaults.set('language', 'ja');


import 'select2/dist/css/select2.css';

export default {
	props: {
	},
	data: () => ({
		
	}),
	
	created() {
		
	},
	
	methods: {
		appendSpeaker($speakerid, $speakername ) {

			var $textarea = $(".minutes-active").closest("tr").find(".minutes_manager");
			var agenda_detail_id = $textarea.attr("agenda_detail_id");
			var minutes_id = $textarea.attr("id");

			var target =  $textarea.attr("judge_minutes");
			this.$emit('domergespeaker', target, agenda_detail_id, minutes_id, $speakerid, $speakername);


		},
		
		saveSpeaker() {
			var $modal = $("#minutes-speaker-modal");
			$modal.find('[name="minutes_speaker"]').focus();
			$(this).focus();
			var $taskarea = $(".minutes-active").closest("tr").find(".table-speaker-area .minutes_speaker_block");
			var $speakerid = this.nullToEmpty($modal.find('[name="minutes_speaker"]').val());
			var $speakername = $modal.find('[name="minutes_speaker"] option:selected').attr('user_name');

			this.appendSpeaker($speakerid, $speakername);

			if ($speakerid != "") {
				$modal.find('.speaker_history').find('[userid="' + this.escapeSelectorString($speakerid) + '"]').remove();
				$modal.find('.speaker_history').prepend($("<span></span>").attr("userid", $speakerid));
			}

			this.$nextTick(() => {
					$("#minutes-speaker-modal").modal("hide");
			});

		},
		
		nullToEmpty(str) {
			return (str == null) ? "" : str;
		},
		
		escapeSelectorString(val){
			if(!isNaN(val)){
				return val;
			} else {
				return val.replace(/[ !"#$%&'()*+,.\/:;<=>?@\[\\\]^`{|}~]/g, "\\$&");
			}
		},
		
		getAttendList() {
			const $speakerlist = [];
			if ($(".PersonList .PersonBlock").length) {
				$.each($(".PersonList .PersonBlock"),function(i,elem) {
					const $elem = $(elem);
					const $users = {USER_ID : $elem.attr("user_id"), USER_NAME : $elem.find(".Person").text()};
					$speakerlist.push($users);
				});
			}
			if ($(".GuestPersonList .GuestPersonBlock").length) {
				$.each($(".GuestPersonList .GuestPersonBlock"),function(i,elem) {
					const $elem = $(elem);
					const $users = {USER_ID : $elem.attr("user_id"), USER_NAME : $elem.find(".GuestPerson").text()};
					$speakerlist.push($users);
				});
			}
				
			if ($("#attend_other .Person").length) {
				$.each($("#attend_other .Person"),function(i,elem) {
					const $elem = $(elem);
					const $users = {USER_ID : $elem.attr("user_id"), USER_NAME : $elem.text()};
					$speakerlist.push($users);
				});
			}
			if ($("#attend_other_guest .GuestPerson").length) {
				$.each($("#attend_other_guest .GuestPerson"),function(i,elem) {
					const $elem = $(elem);
					const $users = {USER_ID : $elem.attr("user_id"), USER_NAME : $elem.text()};
					$speakerlist.push($users);
				});
			}
			return $speakerlist;
		},
		
		eventStop(e) {
			  e.preventDefault();
			  e.stopPropagation();
			  e.stopImmediatePropagation();
		},
		
		makeSelect2(element, value, width, placeholder, allowClearFlag, setValueFlag, tagFlag, optionLength, event) {
			$(element).addClass("select2-clear-flag");
			if ($(element).hasClass("presenter_detail")) {
				const $attendlist = $(".PersonList .PersonBlock");
				var tempid = $(element).val();
				$(element).empty();
				$.each($attendlist, function(i, personblock) {
					var userid = $(personblock).attr("user_id");
					var username = $(personblock).attr("user_name")
					var $op = $('<option></option>').val(userid).text("[" + userid + "] " + username );

					$(element).append($op.clone(false));
					if (event != null) {
						if (!$(event.target).hasClass("btn") && tempid != "" && userid == tempid) {
							var value = tempid;
						} else if ($(event.target).closest(".agenda_row").length || $(event.target).closest(".agenda-main-box").length) {
							var value = "";
						}
					}  
				})
				const $guestattendlist = $(".GuestPersonList .GuestPersonBlock");
				$.each($guestattendlist, function(i, guestpersonblock) {
					var userid = $(guestpersonblock).attr("user_id");
					var username = $(guestpersonblock).find(".GuestPerson").text();
					var $op = $('<option></option>').val(userid).text(username);
					$(element).append($op.clone(false));
				})
			} 
			var setplaceholder = "";
			if (placeholder != "") {
				setplaceholder = placeholder+"を選択";
			}
			
			$(element).select2({
				dropdownAutoWidth: false,
				width: width,
				placeholder: setplaceholder,
				allowClear: allowClearFlag,
				dropdownParent: $(element).parent(),
				language: 'ja',
				tags: tagFlag,
				minimumResultsForSearch: optionLength
			})

			if (setValueFlag) {
				$(element).val(value).trigger('change');
			}  

			$(".select2-clear-flag").on('select2:clear', function (e) {
				$(".select2-clear-flag").select2("close");
			});
		},
	},
	
	mounted() {
		const _self = this;
		
		$("#minutes-speaker-modal").on("hidden.bs.modal", function(e) {
			$(this).find('form').trigger('reset');
			$(".minutes-active").closest(".minutes_manager_area").find(".minutes_manager").focus();
		});
		
		$("#minutes-speaker-modal").on("show.bs.modal", function(e) {
			
			const $modal = $("#minutes-speaker-modal");
			$modal.find('[name="minutes_speaker"] option').remove();

			var $val = $(".minutes-active").closest(".minutes_manager_area").find(".additional-info-speaker .minutes_speaker_span").attr("speaker");
			var attendlist = _self.getAttendList();
			var historylist = [];

			$.each( $modal.find('.speaker_history span') ,function(i,elem) {
				var speakeruserobj = attendlist.find((v) => v.USER_ID === _self.escapeSelectorString($(this).attr("userid")));
				if(speakeruserobj != undefined) {
					historylist.push(speakeruserobj);
					if($val == speakeruserobj["USER_ID"]) {
						$modal.find('[name="minutes_speaker"]').append($("<option user_name='" + speakeruserobj["USER_NAME"] + "'selected></option>").val(speakeruserobj["USER_ID"]).text("[" + speakeruserobj["USER_ID"] + "] " + speakeruserobj["USER_NAME"]));
					} else {
						$modal.find('[name="minutes_speaker"]').append($("<option user_name='" + speakeruserobj["USER_NAME"]+ "'></option>").val(speakeruserobj["USER_ID"]).text("[" + speakeruserobj["USER_ID"] + "] " + speakeruserobj["USER_NAME"]));
					}
				}
			});

			$.each(attendlist,function(i,elem) {
				var speakeruserobj = historylist.find((v) => v.USER_ID === elem["USER_ID"]);
				if(speakeruserobj != undefined) {
					return;
				}
				if($val == elem["USER_ID"]) {
					$modal.find('[name="minutes_speaker"]').append($("<option user_name='" + elem["USER_NAME"] + "' selected></option>").val(elem["USER_ID"]).text("[" + elem["USER_ID"] + "] " + elem["USER_NAME"]));
				} else {
					$modal.find('[name="minutes_speaker"]').append($("<option user_name='" + elem["USER_NAME"] + "'></option>").val(elem["USER_ID"]).text("[" + elem["USER_ID"] + "] " + elem["USER_NAME"]));
				}
			});
			
			_self.makeSelect2($modal.find('[name="minutes_speaker"]'), "", "100%", "発言者", true, false, false, 0);

			const $li = _self.nullToEmpty($modal.find('[name="minutes_speaker"]').val());
			if($li.length) {
				$modal.find("button[name='minutes-btn-delete']").css("display", "block");
			} else {
				$modal.find("button[name='minutes-btn-delete']").css("display", "none");
			}
		});
		
		$("#minutes-speaker-modal").on("shown.bs.modal", function(e) {
			const $modal = $("#minutes-speaker-modal");
			$modal.find('[name="dummytext"]').css("visibility", "visible");
			$modal.find('[name="dummytext"]').focus();
			$modal.find('[name="dummytext"]').css("visibility", "hidden");

			setTimeout(function(){
				$modal.find('[name="minutes_speaker"]').select2("open");
				document.querySelector('.select2-search__field').focus(); 
			},50);
		});
		
		$("#minutes-speaker-modal").on("keydown", function(e) {
			if(e.keyCode == 13) {
				var $focus = $(':focus');
				if($focus.length && $focus.closest("div").hasClass("minutes_speaker_parent")) {
					_self.saveSpeaker();
				}
				_self.eventStop(e);
			}
		});
		
		$("#minutes-speaker-modal button[name='minutes-btn-delete']").on("click", function(e) {
			const $task = $(".minutes-active").closest(".minutes_manager_area").find(".additional-info-speaker .minutes_speaker_span");
			$task.remove();
			$("#minutes-speaker-modal").modal("hide");
		});
		
		$("#minutes-speaker-modal [name='minutes_speaker']").on('select2:select', function (e) {
			var $focus = $(':focus');
			if($focus.length && $focus.closest("div").hasClass("minutes_speaker_parent")) {
				_self.saveSpeaker();
			}
			_self.eventStop(e);
		});
	}
}
</script>
<style>
.speaker-btn-area {
	display: flex;
	justify-content: end;
}

.speaker-btn-area button {
	font-size: 12px;
	height: fit-content;
}
</style>